import { render, staticRenderFns } from "./ShowPost.vue?vue&type=template&id=1674e3b5"
import script from "./ShowPost.vue?vue&type=script&lang=js"
export * from "./ShowPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports